import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { CreateEventForm } from '@/components/org/CreateEventForm';
import { PageTopNav } from '@/components/nav/PageTopNav';

export default function OrgAddEvent() {
  const navigate = useNavigate();
  const { orgId } = useParams();

  return (
    <div className="container mx-auto">
      <PageTopNav pageName="Add Event" />
      <CreateEventForm
        orgId={orgId}
        eventCreated={(eventId: string) => navigate(`/app/org/${orgId}/event/${eventId}`)}
        closeForm={() => navigate(`/app/org/${orgId}/events`)}
      />
    </div>
  );
}
